import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';

import { InputErrorModule } from '../input-error/input-error.module';
import { ImageInputComponent } from './image-input.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    MaterialModule,
    InputErrorModule
  ],
  exports: [ImageInputComponent],
  declarations: [ImageInputComponent]
})
export class ImageInputModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/image-input/image-input.module.ts